import React, { useState } from 'react';
import { IonicButton } from 'ionic-ui';
import { Check, X } from 'lucide-react';

type Props = {
  className?: string;
  onSave?: () => Promise<void>;
  canSave?: boolean;
  onCancel?: () => void;
  canCancel?: boolean;
};
export default function SettingsActionButtons({
  className = '',
  onCancel,
  onSave,
  canCancel = false,
  canSave = false,
}: Props) {
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const handleSave = async () => {
    if (!onSave || isSaving) return;

    setIsSaving(true);
    await onSave();
    setIsSaving(false);
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
  };

  return (
    <div
      className={`${className} col-span-1 sm:col-span-2 md:col-span-4 w-full space-y-4`}
    >
      <div className="w-full h-[1px] rounded-sm bg-border"></div>
      <div className="flex flex-wrap items-center gap-4 justify-end w-full">
        <IonicButton
          variant="outline"
          type="button"
          className="button-with-icon max-sm:flex-1 min-w-fit"
          onClick={handleCancel}
          disabled={!canCancel}
        >
          <span>cancel</span>
          <X className="size-5" />
        </IonicButton>
        <IonicButton
          type="button"
          className="button-with-icon max-sm:flex-1 min-w-fit"
          onClick={handleSave}
          disabled={!canSave}
        >
          <span>save</span>
          {isSaving ? (
            <span className="block w-4 h-4 rounded-full border border-t-transparent border-white animate-spin"></span>
          ) : (
            <Check className="size-5" />
          )}
        </IonicButton>
      </div>
    </div>
  );
}
